// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MediaGalleryVideo__container-a62df7 {
  margin-inline-start: auto;
  margin-inline-end: auto;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.MediaGalleryVideo__container-a62df7 > div {
  width: 100%;
  height: 100%;
}

.MediaGalleryVideo__video-bc7906 {
  max-width: 100%;
  height: auto;
  max-height: 100%;
  outline: none;
}`, "",{"version":3,"sources":["webpack://./src/main/components/MediaGallery/MediaGalleryContent/MediaGalleryFile/MediaGalleryVideo/MediaGalleryVideo.styles.m.css"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;AACF;;AAEA;EACE,eAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;AACF","sourcesContent":[".container {\n  margin-inline-start: auto;\n  margin-inline-end: auto;\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.container > div {\n  width: 100%;\n  height: 100%;\n}\n\n.video {\n  max-width: 100%;\n  height: auto;\n  max-height: 100%;\n  outline: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MediaGalleryVideo__container-a62df7`,
	"video": `MediaGalleryVideo__video-bc7906`
};
module.exports = ___CSS_LOADER_EXPORT___;
